module.exports = "<th>Номер объявления</th>\n<td>\n    <div class=\"advanced-browser__item\">\n        <input class=\"s-input s-input_length_l\"\n               ng-model=\"source.id.value\"\n               maxlength=\"16\"\n               cian-limit-number>\n    </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/offer_id.html
// module id = 349
// module chunks = 0